import * as Joi from 'joi';
import { SetPasswordData } from '../../../models';
import {
  getEmailSchema,
  getMasterCodeDropdownSchema,
  getPhoneNumberSchema,
  validateSingaporeCountryWithTransform,
} from '../../../utils/JoiUtils';

const countryCodeKey = 'country code';

const schemaSetPassword = Joi.object<SetPasswordData>({
  setPassword: Joi.string().required().messages({
    'string.empty': 'Password is not allowed to be empty',
    'any.required': 'Password is not allowed to be empty',
  }),
  confirmPassword: Joi.string().required().valid(Joi.ref('setPassword')).messages({
    'any.required': 'Confirm password is not allowed to be empty',
    'any.only': 'Please enter the same password',
  }),
  otpType: Joi.allow(),
  email: getEmailSchema('Email'),
  countryCode: getMasterCodeDropdownSchema(false, countryCodeKey),
  number: Joi.when('countryCode', {
    is: validateSingaporeCountryWithTransform,
    then: getPhoneNumberSchema(false, 'Mobile No.', 8, 8),
    otherwise: getPhoneNumberSchema(false, 'Mobile No.'),
  }),
});

export default schemaSetPassword;
